import { computedClass } from 'utils'
import './style.scss'

function Loader({ active }) {
    const classes = computedClass({
        loader: true,
        'loader--active': active,
    })

    return (
        <div className={classes}>
            <div className="loader__container">
                <div className="loader__icon"></div>
            </div>
        </div>
    )
}

export default Loader
